const BestSellingData =[
    {
        bestSellingTitle:'Load Scale',
        bestSellingPrice:'35,500.00',
        bestSellingImage:'../product-category-image/loader-scale-cate.png',
    },
    {
        bestSellingTitle:'Weight Machine',
        bestSellingPrice:'75,500.00',
        bestSellingImage:'../product-category-image/Weight-Scales.png',
    },
    {
        bestSellingTitle:'Grass Cutter',
        bestSellingPrice:'4,500.00',
        bestSellingImage:'../product-category-image/grass-cutters.png',
    },
    {
        bestSellingTitle:'Room Hitter',
        bestSellingPrice:'10,500.00',
        bestSellingImage:'../product-category-image/room-hitters.png',
    },
    {
        bestSellingTitle:'LED-Light',
        bestSellingPrice:'5,000.00',
        bestSellingImage:'../product-category-image/tube-lights.png',
    },
    {
        bestSellingTitle:'Sprea Machine',
        bestSellingPrice:'15,500.00',
        bestSellingImage:'../product-category-image/sprayer-Machines-02.png',
    }
    ,
    {
        bestSellingTitle:'Animal Mattress',
        bestSellingPrice:'18,000.00',
        bestSellingImage:'../product-category-image/mattress.png',
    },
    {
        bestSellingTitle:'Milk Detector',
        bestSellingPrice:'25,000.00',
        bestSellingImage:'../product-category-image/milk-detector.png',
    }
]
export default BestSellingData;